import React from 'react';
import { Quote } from 'lucide-react';
import { moreTestimonials } from '../data/constants';
export function MoreTestimonials() {
  return <section className="py-16 md:py-24 px-4 max-w-7xl mx-auto" data-id="element-242">
      <div className="text-center mb-10 md:mb-14" data-id="element-243">
        <p className="text-primary font-bold uppercase tracking-widest text-[11px] md:text-sm mb-3" data-id="element-244">
          🇦🇷 Historias reales
        </p>
        <h2 className="text-2xl md:text-4xl font-extrabold leading-tight max-w-3xl mx-auto" data-id="element-245">
          Mujeres de toda Argentina{' '}
          <span className="text-primary" data-id="element-246">contando su transformación</span>
        </h2>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6" data-id="element-247">
        {moreTestimonials.map((t, i) => <a key={i} href="#pricing" className="relative bg-surface border border-zinc-800 hover:border-primary/40 transition-colors p-6 md:p-7 rounded-2xl flex flex-col" data-id="element-248">
            <Quote className="absolute top-5 right-5 w-7 h-7 text-primary/15" data-id="element-249" />

            <div className="text-yellow-400 text-sm mb-4" data-id="element-250">⭐⭐⭐⭐⭐</div>

            <p className="text-zinc-200 italic text-base leading-relaxed mb-5 flex-grow" data-id="element-251">
              "{t.text}"
            </p>

            <div className="flex items-center gap-3 pt-4 border-t border-zinc-800/70" data-id="element-252">
              <div className="w-12 h-12 rounded-full bg-primary/10 border-2 border-primary/40 flex items-center justify-center font-space-grotesk font-bold text-sm text-primary shrink-0" data-id="element-253">
                {t.initials}
              </div>
              <div className="min-w-0" data-id="element-254">
                <div className="font-bold text-white text-sm" data-id="element-255">
                  {t.name}{' '}
                  <span className="text-zinc-500 font-normal" data-id="element-256">· {t.age}</span>
                </div>
                <div className="text-xs text-zinc-500 mt-0.5" data-id="element-257">{t.role}</div>
                <div className="text-xs text-primary/70 mt-0.5" data-id="element-258">
                  {t.location}
                </div>
              </div>
            </div>
          </a>)}
      </div>
    </section>;
}